import * as React from 'react'
import { DestructuredURL, DVString, APIClient, safeBool, serializeFormdata, ItemPrerolls } from 'DVWebNodeUtils'
import { Icon, IconType, BaseComponentProps } from 'DVWebNodeUI'
import * as styles from './WatchlistStatus.module.scss'
import { Tooltip } from './Tooltip'
import fireDraperTrackingEvent from '../../DVWebNodeStorefront/shared/utils/draper';

interface WatchlistStatusProps extends BaseComponentProps {
  watchlistAction: watchlistEndpointResponseAction
  onToggle?: (newAction: watchlistEndpointResponseAction) => void
  prerolls?: ItemPrerolls
}

interface WathlistStatusState {
  endpointPartialURL: string
  isOnWatchlist: boolean
  endpointQuery: { [key: string]: string }
  text?: DVString
  tag?: string
  endpoint?: DestructuredURL
  ajaxEnabled?: boolean
}

interface watchlistEndpointResponseAction {
  text: DVString
  tag: string
  endpoint: DestructuredURL
  ajaxEnabled: boolean
}

interface watchlistEndpointResponse {
  watchlistAction: watchlistEndpointResponseAction
}

const isAlreadyOnWatchlist = (watchlistTag: string) => watchlistTag.toLowerCase() == 'remove'

class WatchlistStatus extends React.Component<WatchlistStatusProps, WathlistStatusState> {
  ajaxEnabled: boolean

  constructor(props: WatchlistStatusProps) {
    super(props)
    this.state = {
      isOnWatchlist: props && props.watchlistAction &&
        (isAlreadyOnWatchlist(props.watchlistAction.tag)),
      endpointPartialURL: props && props.watchlistAction &&
        props.watchlistAction.endpoint.partialURL,
      endpointQuery: props && props.watchlistAction && props.watchlistAction.endpoint.query,
    }
    this.ajaxEnabled = props && props.watchlistAction &&
      safeBool(props.watchlistAction.ajaxEnabled)
    this.sendToggleRequest = this.sendToggleRequest.bind(this)
  }


  sendToggleRequest = (event: React.FormEvent<HTMLFormElement>) => {
    if (!this.ajaxEnabled) {
      return
    }
    event.preventDefault()
    const query = this.state.endpointQuery
    const watchlistParams = serializeFormdata(query)
    const api = new APIClient
    api.call(this.state.endpointPartialURL, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-requested-with': 'XMLHttpRequest' // must be there for WPS not to do the redirect
      },
      body: watchlistParams
    }).then((json: watchlistEndpointResponse) => {
      const action = json.watchlistAction || false
      if (action && action.endpoint) {
        this.setState({
          text: action.text,
          endpointPartialURL: action.endpoint.partialURL,
          endpointQuery: action.endpoint.query,
          isOnWatchlist: isAlreadyOnWatchlist(action.tag),
        }, () => {
          if (this.state.isOnWatchlist && this.props.prerolls) {
            fireDraperTrackingEvent(this.props.prerolls, 'addToWatchlist')
          }
        })
      }
      if (this.props.onToggle)
        this.props.onToggle(json.watchlistAction)

    })

    const active = document.activeElement as HTMLElement
    if (active)
      active.blur()
  }


  queryAsHiddenInputs(query: { [key: string]: string }) {
    const hiddenInputs = []
    for (const key in query) {
      if (query.hasOwnProperty(key)) {
        hiddenInputs.push(<input type="hidden" name={key} defaultValue={query[key]} key={key} />)
      }
    }
    return hiddenInputs
  }

  render() {
    if (!this.state.endpointPartialURL) {
      return null
    }
    const ariaLabel = (this.state.text && this.state.text.string) ||
      (this.props.watchlistAction && this.props.watchlistAction.text &&
        this.props.watchlistAction.text.string)

    return (
      <Tooltip text={(this.state.text && this.state.text.string) || this.props.watchlistAction.text.string}>

        <form className={styles.form} onSubmit={(e) => this.sendToggleRequest(e)}
          action={this.state.endpointPartialURL} method="POST">
          {this.queryAsHiddenInputs(this.state.endpointQuery)}
          <button type="submit"
            aria-label={ariaLabel}
            className={styles.button} >
            {(this.state.isOnWatchlist
              ? <Icon use={IconType.WATCHLIST_ON} className={this.props.className} />
              : <Icon use={IconType.ADD} className={this.props.className} />)
            }
          </button>
        </form>
      </Tooltip>
    )
  }
}
export default WatchlistStatus
